import { useEffect, useState } from "react";

const ThemeToggle = () => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") {
      document.body.classList.add("dark");
      setIsDark(true);
    }
  }, []);

  const handleThemeChange = (event) => {
    if (event.target.checked) {
      document.body.classList.add("dark");
      localStorage.setItem("theme", "dark");
    } else {
      document.body.classList.remove("dark");
      localStorage.setItem("theme", "light");
    }
    setIsDark(event.target.checked);
  };

  return (
    <div className="theme-switch-container">
      <label className="switch">
        <input
          id="theme-toggle-input"
          type="checkbox"
          checked={isDark}
          onChange={handleThemeChange}
        />
        <div className="slider round"></div>
      </label>
    </div>
  );
};

export default ThemeToggle;
